"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECursoTipoCurso = exports.ECursoTipoAva = exports.ECursoGrau = void 0;
var ECursoGrau;
(function (ECursoGrau) {
    ECursoGrau["Creche"] = "-";
    ECursoGrau["Infantil"] = "0";
    ECursoGrau["Fundamental"] = "1";
    ECursoGrau["Medio"] = "2";
    ECursoGrau["Superior"] = "3";
    ECursoGrau["Extra"] = "9";
})(ECursoGrau = exports.ECursoGrau || (exports.ECursoGrau = {}));
var ECursoTipoAva;
(function (ECursoTipoAva) {
    ECursoTipoAva[ECursoTipoAva["Nota"] = 0] = "Nota";
    ECursoTipoAva[ECursoTipoAva["Descritiva"] = 1] = "Descritiva";
})(ECursoTipoAva = exports.ECursoTipoAva || (exports.ECursoTipoAva = {}));
var ECursoTipoCurso;
(function (ECursoTipoCurso) {
    ECursoTipoCurso["Normal"] = "1";
    ECursoTipoCurso["Livre"] = "2";
})(ECursoTipoCurso = exports.ECursoTipoCurso || (exports.ECursoTipoCurso = {}));
